'use client';

import classnames from 'classnames';
import React, { useEffect, useState } from 'react';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { withOpacity } from '@cineamo/ui/src/helpers/color-helper';

import IconButton from '@cineamo/ui/src/button/IconButton';
import { IconUp24 } from '@cineamo/ui/src/icons/ic-up';

const BackToTop: React.FC<{
    domainConfiguration: DomainConfigurationDto;
}> = ({ domainConfiguration }) => {
    const [isVisible, setIsVisible] = useState(false);
    function onBackToTopClick() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    useEffect(() => {
        function handleScroll() {
            if (window.scrollY > 200) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        }
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <IconButton
            icon={IconUp24}
            accessibilityLabel="Back to top"
            onClick={onBackToTopClick}
            classNameButton={classnames('fixed right-[56px] bottom-[56px] p-[12px] rounded-full duration-300 z-[100]', {
                'opacity-100 scale-100': isVisible,
                'opacity-0 scale-0': !isVisible
            })}
            styleButton={{
                backgroundColor: withOpacity(domainConfiguration.style.onBackgroundColor, 0.2),
                color: domainConfiguration.style.onBackgroundColor
            }}
        />
    );
};

export default BackToTop;
